import { render, staticRenderFns } from "./zhibiaoconfigadd.vue?vue&type=template&id=e7f5e93e&scoped=true"
import script from "./zhibiaoconfigadd.vue?vue&type=script&lang=js"
export * from "./zhibiaoconfigadd.vue?vue&type=script&lang=js"
import style0 from "./zhibiaoconfigadd.vue?vue&type=style&index=0&id=e7f5e93e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7f5e93e",
  null
  
)

export default component.exports